import { createContext,useContext } from 'react';

export interface PublicSettings {
  infiintare_firma_enabled: boolean;
  extras_carte_funciara_enabled: boolean;
  asistenta_avocat_enabled: boolean;
  asistenta_juridica_enabled: boolean;
}

export interface PublicSettingsContextType {
  settings: PublicSettings;
  loading: boolean;
  refreshSettings: () => Promise<void>;
}

export const defaultSettings: PublicSettings = {
  infiintare_firma_enabled: true,
  extras_carte_funciara_enabled: true,
  asistenta_avocat_enabled: true,
  asistenta_juridica_enabled: true,
};

export const PublicSettingsContext = createContext<PublicSettingsContextType | null>(null);

export const usePublicSettings = () => {
  const context = useContext(PublicSettingsContext);
  if (!context) {
    throw new Error('usePublicSettings must be used within a PublicSettingsProvider');
  }
  return context;
};
